import React, { useState, JSX } from 'react';

import { Collapse as CollapseExt } from 'react-collapse';

import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styled from '../../../../../Styles/theme';

const collapseClassName = 'packageOption--collapse';

const Container = styled.div({
  [`& > .${collapseClassName}`]: {
    transition: 'height 500ms'
  }
});

const Toggle = styled.div(props => ({
  whiteSpace: 'nowrap',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  borderTop: `${props.theme.bootstrap.borderWidth} solid ${props.theme.bootstrap.gray400}`,
  // borderRadius    : props.theme.bootstrap.borderRadius,
  // backgroundColor : props.theme.bootstrap.gray100,
  color: 'var(--primary)',
  padding: '0.25rem 0.5rem',
  transition: 'background-color 300ms',
  '&:hover': {
    backgroundColor: props.theme.bootstrap.gray300
  }
}));

export interface Properties {
  isOpened?: boolean;
  children: React.ReactNode;
  textMore: string;
  textLess: string;
}

const Collapse = (props: Properties): JSX.Element => {
  const properties = props;

  const [isOpened, setIsOpened] = useState(!!properties.isOpened);

  const text = isOpened ? properties.textLess : properties.textMore;
  const icon = isOpened ? faChevronUp : faChevronDown;

  return (
    <Container>
      <CollapseExt theme={{ collapse: collapseClassName }} isOpened={isOpened}>
        {properties.children}
      </CollapseExt>
      <Toggle onClick={(): void => setIsOpened(!isOpened)}>
        <span>{text}</span>
        <FontAwesomeIcon icon={icon} />
      </Toggle>
    </Container>
  );
};

export default Collapse;
